import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ user, onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-md w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">Delete User</h2>
        </div>

        <p className="text-muted-foreground mb-6">
          Are you sure you want to delete <span className="font-medium text-foreground">{user?.email}</span>? 
          This action cannot be undone and will permanently remove the user and all associated data.
        </p>

        <div className="flex items-center gap-3">
          <Button
            variant="destructive"
            onClick={onConfirm}
            fullWidth
          >
            Delete User
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;